var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { useAccountSummary } from '../../../../const/syf-api-queries';
import { ConfigContext } from '../../context';
import { CardHoldersErrors, CardHoldersFooter } from '../../main-container/components';
import { CardholdersScreen } from '../../typings';
import ManageCardHoldersModalContent from '.';
import ManageCardHoldersSamsModalContent from './sams-modal-content';
import ManageCardholderContextProvider from '../../context/manage-card-holder-modal-context';
var ManageCardHoldersMainModal = function () {
    var _a, _b, _c;
    var _d = useContext(ConfigContext), selectedAccountId = _d.selectedAccountId, handleClose = _d.handleClose;
    var _e = useAccountSummary(selectedAccountId), accountSummaryData = _e.data, isSummaryError = _e.isError, isSummaryFetching = _e.isFetching;
    var isSamsClient = ((_a = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.product) === null || _a === void 0 ? void 0 : _a.clientId) === 'sams';
    var lookupRequestData = {
        creditType: 'CONSUMER',
        membershipNumber: ((_b = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.card) === null || _b === void 0 ? void 0 : _b.partnerId) || '',
        productType: ((_c = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.product) === null || _c === void 0 ? void 0 : _c.type) || ''
    };
    if (isSummaryFetching) {
        return (_jsx("div", __assign({ "data-testid": "skeleton-loader" }, { children: _jsx(VerticalCardLoader, {}) })));
    }
    if (isSummaryError) {
        return (_jsxs(_Fragment, { children: [_jsx(CardHoldersErrors, {}), _jsx(CardHoldersFooter, { isSamsClient: true, handleClose: handleClose, changeScreen: function () { return null; }, currentScreen: CardholdersScreen.INITIAL_SCREEN, usersLimit: "0" })] }));
    }
    return (_jsx(ManageCardholderContextProvider, { children: isSamsClient ? (_jsx(ManageCardHoldersSamsModalContent, { lookupRequestData: lookupRequestData })) : (_jsx(ManageCardHoldersModalContent, {})) }));
};
export default ManageCardHoldersMainModal;
